
import EmptyHelpBox from './EmptyHelpBox.vue';
import NoFilterSearchList from './NoFilterSearchList.vue';
export default {
  name: 'EmptySearchFromNative',
  components: {
    EmptyHelpBox,
    NoFilterSearchList,
  },
};
